import Nano from "@kizmann/nano-ui";
import { default as axios } from "axios";
import { createApp } from "vue";
import { createRouter, createWebHashHistory } from "vue-router";
import { App } from "#pub/app/index.js";

import moment from "moment";
global.moment = moment;

// Load axios config
await import('./config/axios.js');

const app = createApp({
    ...App
});

(await import("#pub/app/index.js")).default(app);
(await import("#pub/crud/index.js")).default(app);
(await import("#pub/table/index.js")).default(app);
(await import("#pub/page/message/index.js")).default(app);
(await import("#pub/page/token/index.js")).default(app);
(await import("#pub/page/task/index.js")).default(app);
(await import("#pub/page/login/index.js")).default(app);
// (await import("#pub/page/series/index.js")).default(app);
// (await import("#pub/page/vod/index.js")).default(app);
// (await import("#pub/page/stream/index.js")).default(app);
// (await import("#pub/page/category/index.js")).default(app);
// (await import("#pub/page/epg/index.js")).default(app);

const routes = [
    {
        path: '/',
        name: 'home',
        component: app._context.components['AppStatus']
    },
    {
        path: '/login',
        name: 'login.index',
        component: app._context.components['LoginIndex']
    },
    {
        path: '/login/:id',
        name: 'login.item',
        component: app._context.components['LoginIndex']
    },
    {
        path: '/message',
        name: 'message.index',
        component: app._context.components['MessageIndex']
    },
    {
        path: '/message/:id',
        name: 'message.item',
        component: app._context.components['MessageIndex']
    },
    {
        path: '/token',
        name: 'token.index',
        component: app._context.components['TokenIndex']
    },
    {
        path: '/token/:id',
        name: 'token.item',
        component: app._context.components['TokenIndex']
    },
    {
        path: '/task',
        name: 'task.index',
        component: app._context.components['TaskIndex']
    },
    {
        path: '/task/:id',
        name: 'task.item',
        component: app._context.components['TaskIndex']
    }
];

const history = createWebHashHistory('/');

const router = createRouter({
    history, mode: 'history', routes
});

app.use(router);

app.use(function (vapp) {
    vapp.config.globalProperties.$http = axios;
});

app.use((vapp) => {
    Nano.Install(vapp);
});

app.mount('#app');